import { render, staticRenderFns } from "./MobileLightBox.vue?vue&type=template&id=1854fd70&"
import script from "./MobileLightBox.vue?vue&type=script&lang=js&"
export * from "./MobileLightBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports